import React from "react";
const Subtitle = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <g clipPath="url(#clip0_8711_174979)">
            <path
                d="M17.4987 2.5H2.4987C1.57822 2.5 0.832031 3.33947 0.832031 4.375V15.625C0.832031 16.6605 1.57822 17.5 2.4987 17.5H17.4987C18.4192 17.5 19.1654 16.6605 19.1654 15.625V4.375C19.1654 3.33947 18.4192 2.5 17.4987 2.5Z"
                stroke="currentColor"
                strokeWidth="1.8"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M8.33333 8.33366V8.16699C8.33333 7.97001 8.29453 7.77496 8.21915 7.59297C8.14377 7.41098 8.03328 7.24562 7.89399 7.10633C7.75471 6.96704 7.58935 6.85656 7.40736 6.78117C7.22537 6.70579 7.03032 6.66699 6.83333 6.66699H6.5C6.10218 6.66699 5.72064 6.82503 5.43934 7.10633C5.15803 7.38764 5 7.76917 5 8.16699V11.8337C5 12.2315 5.15803 12.613 5.43934 12.8943C5.72064 13.1756 6.10218 13.3337 6.5 13.3337H6.83333C7.23116 13.3337 7.61269 13.1756 7.89399 12.8943C8.1753 12.613 8.33333 12.2315 8.33333 11.8337V11.667"
                stroke="currentColor"
                strokeWidth="1.8"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M15.0013 8.33366V8.16699C15.0013 7.97001 14.9625 7.77496 14.8871 7.59297C14.8117 7.41098 14.7013 7.24562 14.562 7.10633C14.4227 6.96704 14.2573 6.85656 14.0753 6.78117C13.8933 6.70579 13.6983 6.66699 13.5013 6.66699H13.168C12.7701 6.66699 12.3886 6.82503 12.1073 7.10633C11.826 7.38764 11.668 7.76917 11.668 8.16699V11.8337C11.668 12.2315 11.826 12.613 12.1073 12.8943C12.3886 13.1756 12.7701 13.3337 13.168 13.3337H13.5013C13.8991 13.3337 14.2807 13.1756 14.562 12.8943C14.8433 12.613 15.0013 12.2315 15.0013 11.8337V11.667"
                stroke="currentColor"
                strokeWidth="1.8"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </g>
        <defs>
            <clipPath id="clip0_8711_174979">
                <rect width="20" height="20" fill="white" />
            </clipPath>
        </defs>
    </svg>
);

export default Subtitle;
